import { Artwork } from "kreate-common/modules/business-types";

export function getPrimaryAcquisitionMethod(
  artwork: Artwork | null | undefined
) {
  return artwork?.populated?.createdBy.flagSuspended
    ? null
    : artwork?.utxo?.datum?.type === "auction-english" ||
      artwork?.englishAuction
    ? "method-auction-english"
    : artwork?.mintingRules?.version === 1
    ? "method-minting-rules-v1"
    : artwork?.utxo?.datum?.type === "marketplace"
    ? "method-marketplace"
    : artwork?.utxo?.datum?.type === "artwork" &&
      artwork.mintingMethod === "reservation-based-minting"
    ? "method-reservation-based-minting"
    : artwork?.utxo?.datum?.type === "artwork" &&
      (!artwork.mintingMethod || artwork.mintingMethod === "on-demand-minting")
    ? "method-on-demand-minting"
    : undefined;
}
